import * as React from 'react';
import * as classess from "@styles/imageRight.module.css";

import welcomeImage from "@images/2.svg";

const ImageRight = () =>{
    return(
        <section className={classess.imageRight}>
            <img src={welcomeImage} alt='Ilustracja malowania obrazu'/>
        </section>
    )
}

export default ImageRight;